import $ from 'jquery';

$.addInit(function(context){
	var base = '.i-checkList';
	$(base, context).each(function(){
		var component = $(this);
		var checkboxes = component.find(base + '-input');
		var checkboxLength = checkboxes.length;

		function init() {
			for (var i = 0; i < checkboxLength; i++) {
				checkboxes[i].addEventListener('change', checkValidity);
			}

			checkValidity();
		}

		function isChecked() {
			for (var i = 0; i < checkboxLength; i++) {
				if (checkboxes[i].checked) return true;
			}

			return false;
		}

		function checkValidity() {
			if (!isChecked()) {
				checkboxes.attr('required', true);
			} else {
				checkboxes.attr('required', false);
			}
		}

		init();
	});
});